import axios from "axios";
import API_BASE_URL from '../config/api';

const API_BASE =
  (process.env.REACT_APP_API_URL || API_BASE_URL).replace(/\/+$/, "") +
  "/api";

function isJwtLike(s) {
  if (!s) return false;
  const t = String(s).trim().replace(/^bearer\s+/i, "");
  return /^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+$/.test(t);
}

function normalizeToken(raw) {
  if (!raw) return "";
  let t = String(raw).trim();

  if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) {
    t = t.slice(1, -1).trim();
  }

  t = t.replace(/^bearer\s+/i, "").trim();
  t = t.replace(/^bearer\s+/i, "").trim();

  if (t === "null" || t === "undefined") return "";
  return t;
}

function tryParseJson(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function readFromStorage(storage) {
  const directKeys = ["token", "authToken", "accessToken", "jwt"];
  for (const k of directKeys) {
    const v = storage.getItem(k);
    const t = normalizeToken(v);
    if (isJwtLike(t)) return t;
  }

  const objKeys = ["user", "auth", "session", "profile"];
  for (const k of objKeys) {
    const raw = storage.getItem(k);
    if (!raw) continue;
    const parsed = tryParseJson(raw);
    const candidates = [
      parsed?.token,
      parsed?.accessToken,
      parsed?.authToken,
      parsed?.jwt,
      parsed?.user?.token,
      parsed?.user?.accessToken,
    ].filter(Boolean);

    for (const c of candidates) {
      const t = normalizeToken(c);
      if (isJwtLike(t)) return t;
    }
  }

  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    const raw = storage.getItem(key);
    const t = normalizeToken(raw);

    if (raw && raw.trim().startsWith("{")) {
      const parsed = tryParseJson(raw);
      const inner = normalizeToken(parsed?.token || parsed?.accessToken || parsed?.jwt || "");
      if (isJwtLike(inner)) return inner;
    }

    if (isJwtLike(t)) return t;
  }

  return "";
}

function readToken() {
  if (typeof window === "undefined") return "";

  const t1 = readFromStorage(window.localStorage);
  if (t1) return t1;

  const t2 = readFromStorage(window.sessionStorage);
  if (t2) return t2;

  return "";
}

function readLanguage() {
  if (typeof window === "undefined") return "es";

  const saved = window.localStorage.getItem("language") || window.sessionStorage.getItem("language");
  if (!saved) return "es";

  const raw = String(saved).toLowerCase().trim();
  if (raw.startsWith("en")) return "en";
  if (raw.startsWith("es")) return "es";
  return "es";
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = readToken();
  const language = readLanguage();

  config.headers = config.headers || {};

  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;

  config.headers["Accept-Language"] = language;

  return config;
});

export default api; 